import styled from 'styled-components'

export const DatePickerWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: ${props => (props.$fullWidth ? '100%' : props.$width || '100%')};
	max-width: ${props => (props.$fullWidth ? '100%' : props.$width || '362px')};
`

export const InputsRow = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 12px;
	width: 100%;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
        flex-direction: ${props => (props.$stackOnMobile ? 'column' : 'row')};
	}
`

export const InputColumn = styled.div`
	flex: 1;
	min-width: 0;
`

export const CalendarPopover = styled.div`
	position: absolute;
	left: 0;
	top: ${props => props.$top || 'calc(100% + 8px)'};
	z-index: 10;
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
	max-width: 336px;
	min-width: 320px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
		min-width: 0;
		max-width: 336px;
	}

 .react-datepicker__month-container{
        width: 100%;}

        .react-datepicker-wrapper {
            width: 100%;
    }

        .react-datepicker__input-container {
            width: 100%;
    }

        input {
            width: 100%;
        padding: 10px 40px 10px 16px;
        border: 1px solid rgb(152, 152, 152);
        border-radius: 8px;
        font-size: 16px;
        background-color: white;

        &:focus {
            outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
        }
    }

        .react-datepicker {
            border: 1px solid #ddd;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        font-family: inherit;
    }

        .react-datepicker__header {
        background-color: ${props => props.theme.colors.brand.blueOmint};
        border-bottom: 1px solid ${props => props.theme.colors.brand.blueOmint};
    }

        .react-datepicker__day-name,
        .react-datepicker__day {
            width: 2.3rem;
        line-height: 2.3rem;
    }

.react-datepicker__day-name{
color: white;}
	
        .react-datepicker__day--selected,
        .react-datepicker__day--keyboard-selected,
        .react-datepicker__day--in-selecting-range.react-datepicker__day--range-start,
        .react-datepicker__day--in-selecting-range.react-datepicker__day--range-end,
        .react-datepicker__day--in-range {
            background-color: ${props => props.theme.colors.brand.blueOmint};
        color: white;
    }

        .react-datepicker__day--range-start,
        .react-datepicker__day--range-end {
            background-color: ${props => props.theme.colors.brand.blueOmint};
        color: white;
    }

        .react-datepicker__day--in-range {
            background-color: #e3f2fd;
        color: #333;
    }

        .react-datepicker__day:hover {
            background-color: #f0f0f0;
    }

        .react-datepicker__day--selected:hover,
        .react-datepicker__day--in-range:hover {
            background-color: ${props => props.theme.colors.brand.blueOmint};
        color: white;
    }

        .react-datepicker__current-month {
            color: white;
        font-weight: 600;
    }
`

export const MessageText = styled.span`
	display: block;
	font-size: 14px;
	color: ${props => (props.$error ? props.theme.colors.feedback.error || '#D32F2F' : '#6b7280')};
	position: absolute;
  	bottom: -20px;
  	left: 0;
`